import { Action, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { startSessionSuccess } from '../actions/session.actions';
import { isRedirectSessionState, SessionRedirectState, SessionState } from '../../types/session';
import { RootState } from '../store';
import { changeSessionState } from './session.slice';
import { chooseBank } from '../thunks/bank-selection.thunk';

type State = { init: true; URL: string } | { init: false };

const initialState: State = { init: false } as State;

export const redirectionSlice = createSlice({
	name: 'redirection',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(chooseBank.fulfilled, (state, action) => {
			const nextSessionState = action.payload.nextSessionState;
			if (!isRedirectSessionState(nextSessionState)) return state;

			return {
				init: true,
				URL: nextSessionState.result.url
			};
		});

		builder.addMatcher(isSessionStateChange, (redirectionState, action) => {
			const state = action.payload;
			if (!isRedirectState(state)) return redirectionState;

			return {
				init: true,
				URL: state.result.url
			};
		});
	}
});

const isSessionStateChange = (action: Action): action is PayloadAction<SessionState> => {
	return action.type === startSessionSuccess.type || action.type === changeSessionState.type;
};

const isRedirectState = (state: SessionState): state is SessionRedirectState => {
	return state.status === 'CONSUMER_INPUT_NEEDED' && state.result.type === 'redirect';
};

// SELECTORS

export const selectRedirectionURL = (state: RootState) => {
	const redirection = state.redirection;
	if (!redirection.init) return undefined;
	return redirection.URL;
};
